var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvStation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#1f1f1f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m337-214 88-140h-53v-105l-87 140h52v105ZM220-552h269v-228H220v228Zm0 372h269v-312H220v312Zm-60 60v-660q0-24 18-42t42-18h269q24 0 42 18t18 42v288h65q20.71 0 35.36 14.64Q664-462.71 664-442v219q0 22 17.5 36.5T722-172q23 0 43-14.5t20-36.5v-387h-15q-12.75 0-21.37-8.63Q740-627.25 740-640v-90h20v-50h30v50h40v-50h30v50h20v90q0 12.75-8.62 21.37Q862.75-610 850-610h-15v386.69Q835-180 801-150t-79.18 30q-44.16 0-75.99-30T614-223v-219h-65v322H160Zm329-60H220h269Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvStation);
export default __webpack_public_path__ + "static/media/ev-station.adecdfe5661c23b2d44f52532c247fec.svg";
export { ForwardRef as ReactComponent };